<template>
  <!-- 骨架屏 -->
  <div class="skeleton-img">
      <img src="@/assets/img/skeleton/entry-skeleton.png" alt="">
  </div>
</template>
<script>
export default {
    name: 'skeleton'
}
</script>

<style scoped >
    .skeleton-img img{
        width: 100vw ;
        height: 100vh ;
    }
</style>
<style>
    body{
        margin: 0 ;
    }
</style>




// WEBPACK FOOTER //
// src/components/skeleton/skeleton.vue